import type { AdminFilterOption } from './organizationFilters';

export const INVOICE_STATUS_FILTERS: AdminFilterOption[] = [
  { value: 'paid', label: 'Paid' },
  { value: 'open', label: 'Open' },
  { value: 'draft', label: 'Draft' },
  { value: 'uncollectible', label: 'Uncollectible' },
  { value: 'void', label: 'Void' },
];

export type AdminInvoiceFilters = {
  status: string;
};

export const EMPTY_INVOICE_FILTERS: AdminInvoiceFilters = {
  status: '',
};
